// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ow-0";